import api from 'src/utils/api';
import { setServerSession } from 'src/modules/shared/auth/actions';
import * as log from 'loglevel';

export const setResponseCookie = (res, cookieName, cookieValue, httpOnly = false, secure = true) => {
  res.cookie(cookieName, cookieValue, {expires: new Date(Date.now() + 31536000000), httpOnly, secure});
};

export const setSession = async (sessionId, res, dispatch) => {
  try {
    if (!sessionId) {
      const { data: { meta: { session } } } = await api.auroraGet('session/info');
      setResponseCookie(res, 'huSessID', session, true, true);
      dispatch(setServerSession(session));
    } else {
      setResponseCookie(res, 'huSessID', sessionId, true, true);
      dispatch(setServerSession(sessionId));
    }
  } catch (ex) {
    log.error(ex, 'Error setting session');
  }
};
